__turbopack_context__.v({
  "className": "grape_nuts_9020a799-module__XhO0IW__className",
});
